import { getStore as getPeekStore } from 'owa-calendar-peek';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import * as React from 'react';
import { useCalendarAssetCallbacks } from 'owa-timestream-asset-sdk-calendars';
import type { CalendarEventPeekCalloutProps } from '../components/CalendarEventPeekCallout';
import type { ReadingPaneSection } from 'owa-calendar-helpers-types/lib/ReadingPaneSection';

export function useCalendarEventsPeekCalloutState(props: CalendarEventPeekCalloutProps) {
    const callbacks = useCalendarAssetCallbacks();

    const onOpenEventClicked = React.useCallback(
        (ev?: React.MouseEvent<HTMLElement>, scrollToSection?: ReadingPaneSection) => {
            const { itemId } = getPeekStore().viewState;
            callbacks.onOpenCalendarItem(itemId, scrollToSection);
            props.onDismissed();
        },
        [callbacks.onOpenCalendarItem, props.onDismissed]
    );

    const onReviewProposedNewTimeClicked = React.useCallback(
        (newEvent?: Partial<CalendarEvent>) => {
            const { itemId } = getPeekStore().viewState;
            callbacks.onReviewProposedNewTime(itemId, newEvent);
            props.onDismissed();
        },
        [callbacks.onReviewProposedNewTime, props.onDismissed]
    );

    return {
        onOpenEventClicked,
        onReviewProposedNewTimeClicked,
    };
}
